function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.5,
  d: "M500.1 9.9C229.4 9.9 10 229.1 10 499.8s219.4 490.3 490.1 490.3S990 770.5 990 499.8C990 229.1 770.7 9.9 500.1 9.9zm.2 869.3c-209.5 0-379.6-169.9-379.6-379.5 0-209.4 170-379 379.6-379 209.2 0 379 169.6 379 379-.1 209.7-169.8 379.5-379 379.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.5,
  d: "M457.7 645.5h93v-72.7c0-19.6 9.2-38 33.8-54.2 24.3-16.1 92.7-48.6 92.7-134.1 0-85.7-71.8-144.7-132-157.2-60.5-12.5-125.9-4.3-172.1 46.5-41.6 45.3-50.3 81.5-50.3 160.9h93v-18.6c0-42.1 4.9-86.9 65.4-99.1 33-6.7 64 3.8 82.3 21.6 21.1 20.6 21.1 66.7-12.3 89.9L498.7 464c-30.6 19.8-40.9 41.6-40.9 73.7v107.8h-.1zM504.3 681.9c26.3 0 47.8 21.4 47.8 47.9s-21.5 47.8-47.8 47.8c-26.6 0-48.3-21.4-48.3-47.8.1-26.5 21.7-47.9 48.3-47.9z"
});

function SvgTooltipIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip-icon.fb2eb844.svg";
export { ForwardRef as ReactComponent };